import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

/* LAYOUTS */
import AuthLayout from "../themes/layouts/AuthLayout"
import MainLayout from "../themes/layouts/MainLayout"

/* MODULES */
import LoginRoutes from "../modules/auth/routes"
import DashboardRoutes from "../modules/dashboard/routes"
import SettingRoutes from "../modules/settings/routes"
import UserRoutes from "../modules/users/routes"
import PersonRoutes from "../modules/persons/routes"
import RoleRoutes from "../modules/roles/routes"
import PermissionRoutes from "../modules/permissions/routes"
import OrganisationRoutes from "../modules/organisations/routes"
import CourseTemplatesRoutes from "../modules/coursetemplates/routes"
import TennantRoutes from "../modules/tennants/routes"
import LogRoutes from "../modules/logs/routes"
import QueueRoutes from "../modules/queues/routes"
import ClassRoutes from "../modules/classes/routes"
import CourseTypeGroupRoutes from "../modules/coursetypegroups/routes"
import CourseTypeRoutes from "../modules/coursetypes/routes"
import ModuleTemplateRoutes from "../modules/moduletemplates/routes"
import CustomerGroupRoutes from "../modules/customergroups/routes"
import ReportRoutes from "../modules/reports/routes"
import EducationProgramRoutes from "../modules/educationprograms/routes"
import TenantRoleRoutes from "../modules/tenantroles/routes"
import ChecklistRoutes from "../modules/checklist/routes"
import ChecklistTemplateCategoryRoutes from "../modules/checklisttemplatecategory/routes"
import IntegrationRoutes from "../modules/integrations/routes"
import NotificationTemplateRoutes from "../modules/notificationtemplates/routes"
import NotificationRoutes from "../modules/notifications/routes"
import ChangeLogRoutes from "../modules/changelog/routes"
import ModuleRoutes from "../modules/modules/routes"

const routes = [
  {
    path: "/auth/:locale",
    component: AuthLayout,
    children: [...LoginRoutes]
  },
  {
    path: "/app",
    component: MainLayout,
    children: [
      ...DashboardRoutes,
      ...UserRoutes,
      ...PersonRoutes,
      ...RoleRoutes,
      ...PermissionRoutes,
      ...OrganisationRoutes,
      ...SettingRoutes,
      ...CourseTemplatesRoutes,
      ...TennantRoutes,
      ...LogRoutes,
      ...QueueRoutes,
      ...ClassRoutes,
      ...CourseTypeGroupRoutes,
      ...CourseTypeRoutes,
      ...ModuleTemplateRoutes,
      ...CustomerGroupRoutes,
      ...ReportRoutes,
      ...EducationProgramRoutes,
      ...TenantRoleRoutes,
      ...ChecklistRoutes,
      ...ChecklistTemplateCategoryRoutes,
      ...IntegrationRoutes,
      ...NotificationTemplateRoutes,
      ...NotificationRoutes,
      ...ChangeLogRoutes,
      ...ModuleRoutes,
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: "history",
  base: process.env.BASE_URL
})

export default router
